import {createContext, useContext} from "react";

const uiPointerEventsContext = createContext<"auto" | undefined>("auto");

export function useUiPointerEvents() {
  return useContext(uiPointerEventsContext);
}

export const UiPointerEventsProvider = uiPointerEventsContext.Provider;
